import Tabs from "@phoenixreisen/mithrils/src/tabs";
import EmailReset from "./reset.email.m";
import SMSReset from "./reset.sms.m";
import m from "mithril";
export default {
    view() {
        return [
            m(Tabs, { tabs: ["per SMS", "per Email"] }, [m(SMSReset, null), m(EmailReset, null)]),
        ];
    },
};
